<template>
    <Sheet class="container">
        <span class="opps hidden-sm-and-down">OPPS!</span>
        <span class="opps sm hidden-md-and-up">OPPS!</span>
        <h1>404</h1>
        <h3>找不到此頁面!!</h3>
    </Sheet>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
    .container{
        text-align: center;
    }
    .container .opps{
        font-size: 4rem;
        font-weight: bolder;
    }
    .container .opps.sm{
        font-size: 2rem;
    }

</style>
